import Image from "next/image";
import Link from "next/link";
import { Separator } from "./ui/separator";
import { Ultra } from "next/font/google";
import clsx from "clsx";

const ultra = Ultra({
  weight: "400", // Ultra is only available in 400 weight
  subsets: ["latin"],
});

const Preview = ({
  title,
  slug,
  blurredFeaturedImage,
  featuredImage,
  excerpt,
}) => {
  return (
    <Link href={`/blog/${slug}`}>
      <div className="relative h-80">
        <Image
          className="object-cover object-center w-full h-80 rounded-lg"
          src={featuredImage}
          blurDataURL={blurredFeaturedImage}
          alt={title}
          fill
          placeholder="blur"
          objectFit="cover"
        />
      </div>

      <h1 className={clsx("mt-6 text-lg underline", ultra.className)}>
        {title}
      </h1>

      <Separator className="w-32 my-2 border border-muted" />

      <p className="text-base sm:text-sm">{excerpt}</p>

      <p className="underline text-xs italic text-muted-foreground">
        {"Lire la suite"}
      </p>
    </Link>
  );
};

export default Preview;
